import React, { useEffect, useState } from 'react';
import { AdminCheckbox, AdminSelect } from '@project/components';
import { Button, Form } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import styles from './CompanyGeneralTab.module.css';

export default function CompanyGeneralTab({ company, onSaveCompanySettings, companySettings, isSaving }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const [generalSettings, setGeneralSettings] = useState(companySettings.generalSettings);
  const pdfStyleOptions = [
    { label: 'Style 1', value: 1 },
    { label: 'Style 2', value: 2 }
  ]

  useEffect(() => {
    setGeneralSettings(companySettings.generalSettings);
  }, [companySettings]);

  const updateField = (value, base, field) => {
    base[field] = value;
    setGeneralSettings({ ...generalSettings });
  }

  if (!generalSettings) return null;

  const settings = [
    {
      id: 'contactRepresentativeEnabled',
      label: t('CompanyGeneralTab.contactRepresentativeLabel'),
      default: true
    },
    {
      id: 'showCompanyLogoEnabled',
      label: t('CompanyGeneralTab.showCompanyLogoLabel'),
      default: true
    },
    {
      id: 'showCompanyLogoPdfEnabled',
      label: t('CompanyGeneralTab.showCompanyLogoPdfLabel'),
      default: true
    },
    {
      id: 'disablePublicProfiles',
      label: t('CompanyGeneralTab.disablePublicProfilesLabel'),
      default: false
    }
  ];

  const settingsButtons = settings.map((setting) => {
    return (
      <div className='row my-sm-5' key={setting.id}>
        <div className={`col-sm-6 ${styles.basicInfoNode}`}>
          <AdminCheckbox
            id={setting.id}
            label={setting.label}
            checked={typeof generalSettings[setting.id] === 'boolean' ? generalSettings[setting.id] : setting.default}
            onChange={(e) => updateField(e.target.checked, generalSettings, setting.id)} />
        </div>
      </div>
    )
  })

  return (
    <div>
      <div className='row my-sm-5'>
        <div className="font-lg col-sm-8" style={{ lineHeight: '40px' }}>{t('CompanyGeneralTab.description')}</div>
        <div className="col-sm-4" align="right"><Button disabled={isSaving} onClick={() => onSaveCompanySettings({ generalSettings })} >
          {t('CompanyGeneralTab.saveButton')}
        </Button></div>
      </div>
      <Form key="field_visibility_form" className="is-common-form">
        <h2 className='is-main-heading pb-3'>{t('CompanyGeneralTab.title')}</h2>
        {settingsButtons}
        <div className="row my-sm-5">
          <div className="col-sm-6">
            <AdminSelect
              id="defaultPdfStyleSetting"
              label={t('CompanyGeneralTab.defaultPdfStyle.label')}
              placeholder={t('CompanyGeneralTab.defaultPdfStyle.placeholder')}
              value={pdfStyleOptions.find(_ => generalSettings.pdfStyle === _.value) || pdfStyleOptions.find(_ => _.value === 1)}
              onChange={(e) => updateField(e.value, generalSettings, 'pdfStyle')}
              options={pdfStyleOptions}
            />
          </div>
        </div>
      </Form>
    </div>
  )
}
